module.exports = __webpack_public_path__ + "static/img/spht.3cdc6f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/spht.png
// module id = iqj6
// module chunks = 1